import type { ClinicBranding } from '@dnx/contracts';
import { Spinner } from '@dnx/ui';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { BrandEditor } from '../platform/brand-editor.js';
import { SectionHeader } from './layout.js';

export const clinicBrandingQuery = queryOptions({ queryKey: ['clinic', 'branding'], queryFn: () => api<ClinicBranding>('/clinic/branding') });

/** Clínica → Marca: logo, nome, cores e nome do assistente, com a prévia do portal do paciente. */
export function BrandSettingsPage() {
  const qc = useQueryClient();
  const { data } = useQuery(clinicBrandingQuery);
  return (
    <div>
      <SectionHeader title="Marca" description="Como a clínica aparece para o paciente: portal, e-mails e mensagens. Cada publicação vale na hora." />
      <div className="mt-6">
        {!data ? <div className="grid h-40 place-items-center"><Spinner className="size-5 text-fg-subtle" label="Carregando" /></div>
          : <BrandEditor initial={data} endpoint="/clinic/branding" onSaved={() => void qc.invalidateQueries({ queryKey: ['clinic', 'branding'] })} />}
      </div>
    </div>
  );
}
